'use strict';

/**
 * Base controller for the new/create object module
 *
 * @category   Controller
 * @module     create
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Controller = require('base/Colido.Controller');
var CreateLayout = require('./views/layout/create');

var EditModuleController = Controller.extend({
    routes: {
        'catalogs/:catalogId(/*sort)/new(/:epc)(/:scanner)': 'actionCreate',
        'catalogs/:catalogId/duplicate/:objectId': 'actionDuplicate',
    },

    actionCreate: function(catalogId, sort, epc, scanner) {
        this.onDataReady(App.CollectionModule.catalogs, function() {
            var catalog = App.CollectionModule.catalogs.get(catalogId);

            if (!catalog) {
                console.log('@todo: forward to catalog 404');

                return;
            }

            App.requireData([
                catalog.sets,
                catalog.storages,
                App.radio().request('currencies:collection'),
                App.BaseModule.unitsCollection,
            ], function() {
                var layout = new CreateLayout({
                    catalog: catalog,
                    collection: catalog.objects,
                    model: new catalog.objects.model(null, {collection: catalog.objects}),
                    epc: epc,
                    scanner: scanner,
                });

                App.addModal(layout, {
                    additionalClassName: 'edit-object-modal',
                    onBeforeClose: function(data) {
                        return this.modalContent.canBeDestroyed();
                    },
                    onAfterClose: function() {
                        this.modalContent.navigateBack();
                    },
                });
            });
        });
    },

    actionDuplicate: function(catalogId, objectId){
        this.onDataReady(App.CollectionModule.catalogs, function() {
            var catalog = App.CollectionModule.catalogs.get(catalogId);

            if (!catalog) {
                console.log('@todo: forward to catalog 404');

                return;
            }

            App.requireData([
                catalog.objects,
                App.radio().request('currencies:collection'),
                App.BaseModule.unitsCollection,
            ], function() {
                var model = catalog.objects.get(objectId);
                var newModel = new catalog.objects.model(model.toJSON(), {collection: catalog.objects});
                newModel.unset('id', {silent: true});

                _.each(catalog.getEditFields(), function(field){
                    if (field.options.resetOnDuplicate) {
                        newModel.unset(field.name, {silent: true});
                    }
                }.bind(this))

                var layout = new CreateLayout({
                    catalog: catalog,
                    collection: catalog.objects,
                    model: newModel,
                    epc: null,
                    scanner: null,
                });

                App.addModal(layout, {
                    additionalClassName: 'edit-object-modal',
                    onBeforeClose: function(data) {
                        return this.modalContent.canBeDestroyed();
                    },
                    onAfterClose: function() {
                        this.modalContent.navigateBack();
                    },
                });
            });
        });
    },
});

module.exports = EditModuleController;